import React, { useEffect, useState } from 'react';
import { Drawer, Empty, List, Spin, Tag, Typography } from 'antd';
import api from '../api';
import { formatTS } from '../utils/time';

// One person's WFM Skills, read only (GET /api/wfm-skills/user/:id) -- opened
// from Agent Summary's WFM Skills link, for those who can view WFM Skills
// Assign. Changing them stays on that page.
export default function WFMSkillsDrawer({ userId, onClose }) {
  return (
    <WFMSkillsPanel userId={userId} frame={(title, body) => (
      <Drawer open={!!userId} onClose={onClose} width={440} destroyOnClose title={title}>{body}</Drawer>
    )} />
  );
}

// The list itself; `frame` places the title and body (the drawer above), or
// the body alone (Schedule Break & Lunch's person panel).
export function WFMSkillsPanel({ userId, frame }) {
  const [data, setData] = useState(null);
  useEffect(() => {
    if (!userId) { setData(null); return; }
    api.get(`/api/wfm-skills/user/${userId}`)
      .then((r) => setData(r.data))
      .catch(() => setData({ skills: [], error: true }));
  }, [userId]);

  const title = data?.DisplayName ? `WFM Skills · ${data.DisplayName}` : 'WFM Skills';
  const body = (
    <>
      {!data ? <Spin /> : data.error ? <Empty description="Could not load the skills." /> : (
        <>
          {data.TeamName && <Typography.Text type="secondary">Team: {data.TeamName}</Typography.Text>}
          <List
            style={{ marginTop: 8 }}
            dataSource={data.skills}
            locale={{ emptyText: 'No WFM Skills.' }}
            renderItem={(s) => (
              <List.Item>
                <div style={{ width: '100%' }}>
                  <Typography.Text strong>{s.Name}</Typography.Text>
                  {!s.IsActive && <Tag style={{ marginLeft: 8 }}>Inactive</Tag>}
                  {s.Description && <div><Typography.Text type="secondary">{s.Description}</Typography.Text></div>}
                  <div>
                    <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                      Given {s.AssignedAt ? formatTS(s.AssignedAt, 'MM/DD/YYYY') : '—'}
                      {s.AssignedByName ? ` by ${s.AssignedByName}` : ''}
                    </Typography.Text>
                  </div>
                </div>
              </List.Item>
            )}
          />
        </>
      )}
    </>
  );
  return frame ? frame(title, body) : body;
}
